module.exports = __webpack_public_path__ + "img/logo-pro.adf041a8.png";